import React from 'react'

const BlockInfo = ({ title, weeksNumber, orderBy = "asc", isBorder = false }) => {
    return (
        <div className={`w-full h-full flex flex-col items-center justify-end gap-2 ${isBorder ? "border-r-2 border-[#E6E6E6]" : ""} px-2`}>
            <p className={`text-[10px] ${orderBy === "asc" ? "order-1" : "order-2"}`}>{title}</p>
            <p className={`text-[10px] ${orderBy === "asc" ? "order-2" : "order-1"}`}>{weeksNumber}</p>
        </div>
    )
}

export default BlockInfo